import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Form, Input, Select } from "antd";
import { RefreshIcon } from "../../../common/icons";
import GalkButton from "../../../common/component/button";
import "./style.css";

import { getColleges } from "../../../../actions/organisationDataActions";

const { TextArea } = Input;
const { Option } = Select;

const VoiceFormItems = ({
	isActionProgress,
	action,
	cancelActionHandler,
	getColleges,
	colleges,
}) => {
	const { t } = useTranslation();
	const [collegeNames, setCollegeNames] = useState([]);

	useEffect(() => {
		if (colleges.length === 0) getColleges();
	}, [colleges]);

	return (
		<>
			<div className="voiceForm_topActionRow">
				<div className="left">
					<Form.Item
						label={t("accountSetting_voiceOfSenior_card_name")}
						name="name"
						rules={[{ required: true, message: "" }]}
					>
						<Input placeholder="" />
					</Form.Item>
				</div>
				<div className="right">
					<Form.Item>
						<div style={{ display: "flex" }}>
							<GalkButton
								type="secondary"
								height={36}
								additionalStyle={{ padding: "13px 16px" }}
								className="project-form-control-btn"
								onClick={cancelActionHandler}
							>
								{t("createProject_modalAction_cancel")}
							</GalkButton>
							<GalkButton
								type="primary"
								htmlType="submit"
								height={36}
								additionalStyle={{ padding: "13px 16px" }}
								loading={isActionProgress}
							>
								<RefreshIcon width={14} height={14} />
								{action === "create"
									? t("createProject_modalAction_submit")
									: t("editProject_modalAction_submit")}
							</GalkButton>
						</div>
					</Form.Item>
				</div>
			</div>

			<Form.Item
				label={t("accountSetting_voiceOfSenior_card_position")}
				name="position"
				rules={[{ required: true, message: "" }]}
			>
				<Input placeholder="" style={{ width: "50%" }} />
			</Form.Item>
			<Form.Item
				label={t("accountSetting_voiceOfSenior_card_year")}
				name="yearOfEmployment"
				rules={[{ required: true, message: "" }]}
			>
				<Input placeholder="" style={{ width: "50%" }} />
			</Form.Item>
			<Form.Item
				label={t("accountSetting_voiceOfSenior_card_college")}
				name="collegeName"
				rules={[{ required: true, message: "" }]}
			>
				<Select
					placeholder="Select college"
					disabled={isActionProgress}
					style={{ width: "50%" }}
				>
					{colleges.map((clg, i) => (
						<Option key={`clg:${i}`} value={clg}>
							{clg}
						</Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item
				label={t("accountSetting_voiceOfSenior_card_comment")}
				name="comments"
				rules={[{ required: true, message: "" }]}
			>
				<TextArea autoSize={{ minRows: 6, maxRows: 8 }} placeholder="" />
			</Form.Item>
		</>
	);
};

const mapStateToProps = (state) => ({
	colleges: state.organisationData.colleges,
});

export default connect(mapStateToProps, { getColleges })(VoiceFormItems);
